export default "__VITE_PUBLIC_ASSET__e355939b__"